module.exports = __webpack_public_path__ + "static/media/HomeBG.5d10aaf6.jpg";